export const table = {
	defaultCategoryName: "Products",
	exportExcel: "Export Excel",
	productCount: {
		singular: "product",
		plural: "products",
	},
	loading: {
		categories: "Loading categories",
		products: "Loading Products",
	},
	dropdown: {
		editCategory: "Edit category",
		deleteCategory: "Delete category",
		categoryButton: "Category",
	},
	columns: {
		bars: "Bars",
		barsTooltip: "Click to view bars",
		barsLabel: "Bars",
		mountableTooltip: "Click to view mountable product",
		productionRuleTooltip: "Click to view production rule",
		active: "Status",
		mountableDescription: "Mountable",
		fiscalCode: "SKU",
		name: "Product",
		hasProductionRule: "Datasheet",
		fiscalData: "Tax Data",
		value: "Price",
		actions: "Actions",
	},
	fiscalStatus: {
		testedTooltip: "Fiscal data registered and validated",
		errorTooltip: "We found errors in the fiscal data presented",
		notTestedTooltip: "Fiscal data registered. Awaiting test.",
	},
	variablePrice: "Variable",
	validation: {
		pricePositive: "Price must be a positive value",
	},
	priceUpdateSuccess: "The price of {{productName}} has been updated successfully.",
	notifications: {
		copyImageSuccess: {
			title: "Success!",
			description: "Image hash copied to clipboard",
		},
	},
	emptyState: {
		categoryWithoutProducts: "Category without products",
		noProductsFound: "No products found",
		addProducts: "Add products and link to this category.",
		noSearchResults: "We didn't find products that match your search for",
		clearSearchButton: "Clear search",
		clearFiltersButton: "Clear filters",
		andToAppliedFilters: "and to applied filters",
		inCategory: 'in category "{{categoryName}}"',
		noProductsMatchingFilters: "We didn't find products that match the applied filters",
	},
};
